export default __webpack_public_path__ + "static/media/sliderImg1.fa476223.png";